import { useState } from "react"

const useConfirmation = () => {
    const [pendingItems, setPendingItems] = useState([])

    const unmark = (item) => {
        setPendingItems((prev) => prev.filter((pendingItem) => pendingItem !== item))
    }

    const markOrExecute = (item, callback) => {
        if (pendingItems.includes(item)) {
            unmark(item)
            callback(item)
        } else {
            setPendingItems((prev) => [...prev, item])
            setTimeout(() => unmark(item), 3000)
        }
    }

    const isMarked = (item) => pendingItems.includes(item)

    return { markOrExecute, isMarked, pendingItems }
}

export default useConfirmation